/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CarrierDeliveryNotesArrayV3 } from '../../models/carrier-delivery-notes-array-v-3';
import { CarrierDeliveryNotesFilterProperties } from '../../models/carrier-delivery-notes-filter-properties';
import { KeyType } from '../../models/key-type';
import { SortType } from '../../models/sort-type';

export interface GetCarrierDeliveryNotesV3$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;

/**
 * Maximum number of items to return
 */
  limit?: number;

/**
 * Number of items to skip
 */
  offset?: number;

/**
 * Sort direction (asc or desc)
 */
  sort?: SortType;

/**
 * Field to sort by
 */
  sortBy?: 'dateCreated' | 'checkoutDate' | 'checkinDate' | 'dateAnnounced' | 'tourNumber' | 'number' | 'orderNumber' | 'deliveryNoteBundleNumber' | 'deliveryNoteBundleStatus' | 'status' | 'consignorName' | 'carrierName' | 'consigneeName' | 'carrierNumberPlateOutgoing' | 'carrierNumberPlateIncoming' | 'consignorLoadCarrierExchange' | 'originalConsignor' | 'originalConsignorGln' | 'discrepancies' | 'palletTickets' | 'properties' | 'properties.referenceNumber';

/**
 * Array of organization site keys to fetch data from (max 1000). If provided, overrides the path parameter.
 */
  organizationSiteKeys?: Array<KeyType>;

/**
 * Field to filter carrier delivery notes by
 *
 * @deprecated
 */
  filterProperty?: CarrierDeliveryNotesFilterProperties;

/**
 * Value to filter by (partial match)
 *
 * @deprecated
 */
  filterValue?: string;

/**
 * Case-insensitive partial match using the existing number field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  number?: string;

/**
 * Case-insensitive partial match using the existing fileName field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  fileName?: string;

/**
 * Case-insensitive partial match using the existing tourNumber field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  tourNumber?: string;

/**
 * Case-insensitive partial match using the existing orderNumber field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  orderNumber?: string;

/**
 * Case-insensitive partial match using the existing consignorName field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  consignorName?: string;

/**
 * Case-insensitive partial match using the existing carrierName field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  carrierName?: string;

/**
 * Case-insensitive partial match using the existing consigneeName field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  consigneeName?: string;

/**
 * Case-insensitive partial match using the existing originalConsignor field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  originalConsignor?: string;

/**
 * Case-insensitive partial match using the existing originalConsignorGln field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  originalConsignorGln?: string;

/**
 * Case-insensitive partial match using the existing deliveryNoteBundleNumber field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  deliveryNoteBundleNumber?: string;

/**
 * Case-insensitive partial match using the existing discrepancies field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  discrepancies?: string;

/**
 * Case-insensitive partial match using the existing palletTickets field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  palletTickets?: string;

/**
 * Case-insensitive partial match using the existing deliveryNoteBundleStatus field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  deliveryNoteBundleStatus?: string;

/**
 * Case-insensitive partial match using the existing status field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  status?: string;

/**
 * Case-insensitive partial match using the existing dateCreated field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  dateCreated?: string;

/**
 * Case-insensitive partial match using the existing dateAnnounced field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  dateAnnounced?: string;

/**
 * Case-insensitive partial match using the existing checkoutDate field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  checkoutDate?: string;

/**
 * Case-insensitive partial match using the existing checkinDate field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  checkinDate?: string;

/**
 * Case-insensitive partial match using the existing properties field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  properties?: string;

/**
 * Case-insensitive partial match using the existing referenceNumber field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  referenceNumber?: string;

/**
 * Case-insensitive partial match using the existing carrierNumberPlateOutgoing field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  carrierNumberPlateOutgoing?: string;

/**
 * Case-insensitive partial match using the existing carrierNumberPlateIncoming field filter. Combined with every other field filter, filterProperty/filterValue, search and existing toggles using AND. Repeated occurrences are not supported.
 */
  carrierNumberPlateIncoming?: string;

/**
 * Filter for not closed items only (bundles, tours, delivery notes)
 */
  filterNotClosed?: boolean;

/**
 * If true, only return bundles where at least one delivery note has a discrepancy (normal or fine). Uses the bundle.discrepancies flag for efficient filtering.
 */
  filterOnlyDiscrepancies?: boolean;

/**
 * Case- and accent-insensitive substring search across all text fields
 * of the entity (numbers, names, file names, date strings). Minimum 3
 * characters. Can be combined with filterProperty/filterValue (results
 * must match both). Search results are eventually consistent: newly
 * written documents can take about one second to appear.
 */
  search?: string;
}

export function getCarrierDeliveryNotesV3(http: HttpClient, rootUrl: string, params: GetCarrierDeliveryNotesV3$Params, context?: HttpContext): Observable<StrictHttpResponse<CarrierDeliveryNotesArrayV3>> {
  const rb = new RequestBuilder(rootUrl, getCarrierDeliveryNotesV3.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sort', params.sort, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('organizationSiteKeys', params.organizationSiteKeys, {});
    rb.query('filterProperty', params.filterProperty, {});
    rb.query('filterValue', params.filterValue, {});
    rb.query('number', params.number, {});
    rb.query('fileName', params.fileName, {});
    rb.query('tourNumber', params.tourNumber, {});
    rb.query('orderNumber', params.orderNumber, {});
    rb.query('consignorName', params.consignorName, {});
    rb.query('carrierName', params.carrierName, {});
    rb.query('consigneeName', params.consigneeName, {});
    rb.query('originalConsignor', params.originalConsignor, {});
    rb.query('originalConsignorGln', params.originalConsignorGln, {});
    rb.query('deliveryNoteBundleNumber', params.deliveryNoteBundleNumber, {});
    rb.query('discrepancies', params.discrepancies, {});
    rb.query('palletTickets', params.palletTickets, {});
    rb.query('deliveryNoteBundleStatus', params.deliveryNoteBundleStatus, {});
    rb.query('status', params.status, {});
    rb.query('dateCreated', params.dateCreated, {});
    rb.query('dateAnnounced', params.dateAnnounced, {});
    rb.query('checkoutDate', params.checkoutDate, {});
    rb.query('checkinDate', params.checkinDate, {});
    rb.query('properties', params.properties, {});
    rb.query('referenceNumber', params.referenceNumber, {});
    rb.query('carrierNumberPlateOutgoing', params.carrierNumberPlateOutgoing, {});
    rb.query('carrierNumberPlateIncoming', params.carrierNumberPlateIncoming, {});
    rb.query('filterNotClosed', params.filterNotClosed, {});
    rb.query('filterOnlyDiscrepancies', params.filterOnlyDiscrepancies, {});
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CarrierDeliveryNotesArrayV3>;
    })
  );
}

getCarrierDeliveryNotesV3.PATH = '/organization-sites/{organizationSiteKey}/carrier/delivery-notes';
